import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import * as bookingActions from '../../../store/actions/booking.action';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import { map } from 'rxjs/operators';
import { Booking } from '../../models/booking';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-tourinfo',
  templateUrl: './tourinfo.component.html',
  styleUrls: ['./tourinfo.component.css']
})
export class TourinfoComponent implements OnInit, OnDestroy {
  goldReefCitySubscription: Subscription;
  sunCitySubscription: Subscription;
  unionBuildingSubscription: Subscription;
  sowetoSubscription: Subscription;
  tourInfoForm: FormGroup;
  // currentBooking: Booking;
  constructor(
    private fb: FormBuilder,
    private store: Store<State>,
    private router: Router
  ) {}

  ngOnInit() {
    // this.store
    //   .select(state => state.booking.currentBooking)
    //   .subscribe(booking => (this.currentBooking = booking));

    this.createForm();

    this.sowetoSubscription = this.tourInfoForm
      .get('includeSowetoTour')
      .valueChanges.pipe(
        map(value => {
          if (value) {
            this.store.dispatch(new bookingActions.IncludeSowetoTour());
          } else {
            this.store.dispatch(new bookingActions.ExcludeSowetoTour());
          }
        })
      )
      .subscribe();

    this.unionBuildingSubscription = this.tourInfoForm
      .get('includeUnionBuildingTour')
      .valueChanges.pipe(
        map(value => {
          if (value) {
            this.store.dispatch(new bookingActions.IncludeUnionBuildingTour());
          } else {
            this.store.dispatch(new bookingActions.ExcludeUnionBuildingTour());
          }
        })
      )
      .subscribe();

    this.sunCitySubscription = this.tourInfoForm
      .get('includeSunCityTour')
      .valueChanges.pipe(
        map(value => {
          if (value) {
            this.store.dispatch(new bookingActions.IncludeSunCityTour());
          } else {
            this.store.dispatch(new bookingActions.ExcludeSunCityTour());
          }
        })
      )
      .subscribe();

    this.goldReefCitySubscription = this.tourInfoForm
      .get('includeGoldReefCityTour')
      .valueChanges.pipe(
        map(value => {
          if (value) {
            this.store.dispatch(new bookingActions.IncludeGoldReefCityTour());
          } else {
            this.store.dispatch(new bookingActions.ExcludeGoldReefCityTour());
          }
        })
      )
      .subscribe();
  }

  createForm() {
    this.tourInfoForm = this.fb.group({
      includeSowetoTour: false,
      includeUnionBuildingTour: false,
      includeSunCityTour: false,
      includeGoldReefCityTour: false
    });

    // this.tourInfoForm
    //   .get('includeSowetoTour')
    //   .setValue(this.currentBooking.includeSowetoTour);
    // this.tourInfoForm
    //   .get('includeGoldReefCityTour')
    //   .setValue(this.currentBooking.includeGoldReefCityTour);
    // this.tourInfoForm
    //   .get('includeSunCityTour')
    //   .setValue(this.currentBooking.includeSunCityTour);
    // this.tourInfoForm
    //   .get('includeUnionBuildingTour')
    //   .setValue(this.currentBooking.includeUnionBuildingTour);
  }

  submitTourInfo() {
    this.router.navigate(['/bookings/add/confirmation']);
  }

  cancel() {
    this.router.navigate(['/bookings']);
  }

  ngOnDestroy() {
    this.sowetoSubscription.unsubscribe();
    this.sunCitySubscription.unsubscribe();
    this.goldReefCitySubscription.unsubscribe();
    this.unionBuildingSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/tourinfo/tourinfo.component.ts